// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__15STA","savePackageButton":"ClientWallet_savePackageButton__DfaAb"};